<!--
 * @Author       : saisai
 * @Date         : 2021-05-10 14:07:22
 * @LastEditors  : saisai
 * @Description  : 请填写简介
-->
/**
 * @description: 基本信息
 * @author:
 */
<template>
  <div class="base-info">
    <div class="warning-tips" v-if="showWarn">
      <img src="https://uat-jms.jtexpress.com.cn/operatingPlatformIndex/static/img/guohui.4df32376.png">
      <span>{{$lang('公安机关提醒您：贩卖收件人地址、手机号等公民信息的行为严重违反刑法、国家网络安全法等法律，最高可判处7年有期徒刑。')}}</span>
    </div>
    <div v-for="(item, key) in option" :key="key" class="item">
      <div class="title pointer-view">
        {{item.title}}
      </div>
      <div v-for="(row, index) in item.column" :key="index" class="row">
        {{row.label}}:
        <span v-if="row.prop==='receiverFullAddress'">
          {{row.formatter(value)}}
          <el-tag v-if="!value.addressDetail && value.orderSourceCode==='D801'" type="warning" class="address-btn" size="mini" @click="getAddressDetail">{{$lang('详细地址')}}</el-tag>
        </span>
        <!-- 收、寄件人 、虚拟号反查 -->
        <EyesPhone
          v-else-if="item.decode&&row.decode"
          :paramsData="{
            phone:value[row.prop],
            waybillNo: value.waybillNo,
            orderSourceCode:value.orderSourceCode,
            queryType: row.type,// 1:寄件 2：收件 3:虚拟号
          }"
        />
        <span v-else-if="row.formatter && typeof row.formatter === 'function'">{{row.formatter(value)}}</span>
        <span v-else-if="row.prop==='orderSignName' && (value['orderSignList'] || []).length">
          <span v-for="o in value['orderSignList']" :key="o">
            <div v-if="o.fieldCode === 'JYfirst'" class="div-click div-click-one" @click="orderSignClick(value.waybillNo,'firstNo')">{{$lang(' 集运一段')}}</div>
            <div v-if="o.fieldCode === 'JYsecond'" class="div-click div-click-two" @click="orderSignClick(value.waybillNo,'secondNo')">{{$lang(' 集运二段')}}</div>
            <div v-if="o.fieldCode === 'JYthird'" class="div-click div-click-three" @click="orderSignClick(value.waybillNo,'thirdNo')">{{$lang(' 集运三段')}}</div>
            <div v-if="!['JYfirst','JYsecond','JYthird'].includes(o.fieldCode)" class="div-click div-click-else">{{$lang(o.fieldValue)}}</div>
          </span>
        </span>
        <span v-else>{{value[row.prop]}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { baseInfo } from './option'
import showOrderSignMixin from '@/common/mixin/showOrderSignMixin'
export default {
  mixins: [showOrderSignMixin],
  data() {
    return {
      option: baseInfo
    }
  },
  props: {
    encryption: Boolean,
    showWarn: Boolean,
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isEncryption() {
      const { senderMobilePhone, receiverMobilePhone } = this.value
      return this.encryption && (senderMobilePhone && senderMobilePhone.match(/\*/) || receiverMobilePhone && receiverMobilePhone.match(/\*/))
      // return true
    }
  },
  methods: {
    // 获取详细地址
    getAddressDetail() {
      this.$emit('getAddressDetail')
    }
  },
  watch: {
    value() {
      this.virtualCodeList = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.warning-tips{
  text-align: center;
  margin-bottom: -10px;
  img{
    height: 20px;
    margin: 5px;
    vertical-align: middle;
  }
  span{
    display: inline-block;
    margin-left: 5px;
    vertical-align: middle;
    line-height: 20px;
    font-weight: bold;
    color: #000;
  }
}
.base-info {
  overflow: hidden;
  font-size: 12px;
  line-height: 22px;
  .item {
    width: 280px;
    height: 241px;
    float: left;
    margin-right: 15px;
    margin-top: 20px;
    border: 1px solid #ddd;
    @include border-color('lighter');
    box-sizing: border-box;
    padding: 5px 20px 0;
  }
  .title {
    font-size: 14px;
    line-height: 44px;
    @include base-color('clr');
  }
  .iconfont {
    line-height: 0;
  }
  .row {
    @include text-color('routine');
  }
  .text-click{
  color:#3a40f5;
  cursor: pointer;
}
  .div-click{
    display: inline-block;
    width: 55px;
    height: 25px;
    text-align: center;
    cursor: pointer;
    border-radius: 7px;
    margin-right: 1px;
    border: red 1px solid;
  }
  .div-click-one{
    border: #c18339 1px solid;
    color:#c18339;
    background-color: #facd91;
  }
  .div-click-two{
  border:#88acb9 1px solid;
  color:#88acb9;
  background-color: #e3f2f8;
  }
  .div-click-three{
  border: #94a0c8 1px solid;
  color:#94a0c8;
  background-color: #dde2f4;
  }
  .div-click-else{
  border: #338fe5 1px solid;
  color:#338fe5;
  background-color: #99c7f2;
  cursor: initial;
  }
}
</style>
